import { derivedThemeValues } from '@/services/widgetTheme/derivedValues'; // Define the dark theme colors

export const COLOR = derivedThemeValues(_ref => {
  let {
    theme
  } = _ref;
  return {
    bodyBackground: '#000000',
    border: '#343B45',
    borderMuted: '#22262e',
    borderHover: '#4C5563',
    primary: theme.color.primary,
    secondary: '#22262E',
    secondaryHover: '#343B45',
    bodyFont: '#ffffff',
    headingFont: '#ffffff',
    subheadingFont: theme.color.gray500,
    mutedFont: theme.color.gray500
  };
}); // Base colors for the theme
// from light to dark

export const BASE_COLORS = ['#22262e', '#343b45', '#4c5563', '#626d7c', '#848e9e', '#a2abb8', '#c3c9d1', '#e2e5eb']; // Dark theme color pallets

export const COLOR_PALLETS = [{
  name: 'Default',
  colors: ['#3259e8', ...BASE_COLORS]
}, {
  name: 'Success',
  colors: ['#00823e', ...BASE_COLORS]
}, {
  name: 'Danger',
  colors: ['#c32518', ...BASE_COLORS]
}];